var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.7184 5.05531H13.3276V0H7.89277V5.05531H4.50195L10.6101 13.2319L16.7184 5.05531ZM9.1427 6.30531V1.25H12.0775V6.30531H14.2243L10.6101 11.1433L6.99595 6.30531H9.1427Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M16.7039 11.25V15.625H4.51636V11.25H0.453857V20H20.7664V11.25H16.7039ZM19.5164 18.75H1.70386V12.5H3.26636V16.875H17.9539V12.5H19.5164V18.75Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.653ebf6c5b20b4c12b75828dd2677922.svg";
export { ForwardRef as ReactComponent };